var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"data-t-name":"tab_accordion"}},[_c(_vm.isAccordion ? 'BaseAccordion' : 'BaseTab',{ref:"child",tag:"component",attrs:{"wrap":false},on:{"unmounted-index":_vm.setActiveIndex}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }